import { Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "../ui/alert-dialog";

export function ClearCheckedButton({ checkedCount, onClear }) {
  if (checkedCount === 0) {
    return null;
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <div className="flex justify-center pt-4">
          <Button
            variant="outline"
            className="border-slate-700 text-slate-400 hover:text-red-400 hover:border-red-800"
            data-testid="clear-checked-button"
          >
            <Trash2 size={16} className="mr-2" />
            Clear {checkedCount} Checked Item{checkedCount !== 1 ? "s" : ""}
          </Button>
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-slate-900 border-slate-800">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-white">
            Clear checked items?
          </AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            This will permanently remove {checkedCount} checked item
            {checkedCount !== 1 ? "s" : ""} from your shopping list. This action
            cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className="border-slate-700"
            data-testid="cancel-clear-checked"
          >
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onClear}
            className="bg-red-600 hover:bg-red-500"
            data-testid="confirm-clear-checked"
          >
            Clear Items
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
